import { useCallback, useRef } from 'react';

const target = 'WebPageEventListener';

/** @type {NodeJS.Timeout | false} */
let sent = false;
let lastTime = 0;

/**
 *
 * @param {{
 *    context: {
 *      sendMessage: (target: string, event: string, payload: any) => void
 *    },
 *    Hash: string | null,
 *    visible: boolean,
 *    debug: boolean
 * }} options
 * @returns {[
 *    (event: string, data?: any) => void,
 *    (event: string) => (data?: any) => void
 * ]}
 */
export const useEmbedMessages = ({ context, Hash, visible, debug }) => {
  const visibleRef = useRef(visible);
  visibleRef.current = visible;

  const contextRef = useRef(context);
  contextRef.current = context;

  const send = useCallback(
    /**
     * @param {string} event
     * @param {any} data
     */
    (event, data) => {
      if (!contextRef.current) {
        return;
      }
      const payload = ['number', 'string'].includes(typeof data)
        ? data
        : JSON.stringify(data);

      debug && console.log('virti-debug', '<-', event, data);
      contextRef.current.sendMessage(target, event, payload);
    },
    [debug]
  );

  const postEvent = useCallback(
    /**
     * @param {string} event
     */
    (event) =>
      /**
       * @param {any} data
       */
      (data) => {
        if (event === 'onCurrentTime') {
          if (!sent && lastTime !== data) {
            sent = setTimeout(() => (sent = false), 1000);
            debug && console.log('virti-debug', '->', event, data);
            lastTime = data;
          }
        } else {
          sent = false;
          debug && console.log('virti-debug', '->', event, data);
        }
        window.parent.postMessage({
          event,
          Hash,
          data,
        });
        if (event === 'onPlayerLoaded') {
          send('PlayerVisible', visibleRef.current);
        }
      },
    [Hash, debug, send]
  );

  return [send, postEvent];
};
